define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FWpDoc", "../entity/FWpPr", "../entity/FWpAsset", "../entity/FWpEoiInfo", "../domain", "../services", "../services/EventManager", "./FWpApproval"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FWpDoc_1, FWpPr_1, FWpAsset_1, FWpEoiInfo_1, domain_1, services_1, EventManager_1, FWpApproval_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWorksProject = void 0;
    class FWorksProject extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EoiApproxCost", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EoiApproxCostError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Quote", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QuoteError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovedAmt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovedAmtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ClaimAmt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ClaimAmtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PaidAmt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PaidAmtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RecContractor", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RecContractorError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateEoi", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateEoiError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DatePa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DatePaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateQuoted", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateQuotedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateApproved", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateApprovedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateClaimed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateClaimedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DatePaid", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DatePaidError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateWithdrawn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DateWithdrawnError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsForm2Provided", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsForm2ProvidedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsForm3Provided", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsForm3ProvidedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AreMinReqsMet", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AreMinReqsMetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpPr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpPr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpPrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpEoiInfo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpEoiInfo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpEoiInfoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Facility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Approval", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewDocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "IsLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWorksProject.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Facility = parent;
            this.FacilityId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FWpDoc = [];
            this.FWpPr = [];
            this.FWpAsset = [];
            this.FWpEoiInfo = [];
        }
        onRead(entity, parent) {
            this.Facility = parent;
            this.FWpDoc = [];
            this.FWpPr = [];
            this.FWpAsset = [];
            this.FWpEoiInfo = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.FacilityId = (0, EntityUtil_1.toInt)(entity.FacilityId);
            a.RefId = b.RefId;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.Desc_ = b.Desc_;
            a.UserComment = b.UserComment;
            a.EoiApproxCost = (0, EntityUtil_1.toFloat)(entity.EoiApproxCost);
            a.Quote = (0, EntityUtil_1.toFloat)(entity.Quote);
            a.ApprovedAmt = (0, EntityUtil_1.toFloat)(entity.ApprovedAmt);
            a.ClaimAmt = (0, EntityUtil_1.toFloat)(entity.ClaimAmt);
            a.PaidAmt = (0, EntityUtil_1.toFloat)(entity.PaidAmt);
            a.RecContractor = b.RecContractor;
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.StatusReq = (0, EntityUtil_1.toInt)(entity.StatusReq);
            a.StatusPrev = (0, EntityUtil_1.toInt)(entity.StatusPrev);
            a.StatusDate = b.StatusDate;
            a.StatusUser = b.StatusUser;
            a.StatusComment = b.StatusComment;
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.DateEoi = b.DateEoi;
            a.DatePa = b.DatePa;
            a.DateQuoted = b.DateQuoted;
            a.DateApproved = b.DateApproved;
            a.DateClaimed = b.DateClaimed;
            a.DatePaid = b.DatePaid;
            a.DateWithdrawn = b.DateWithdrawn;
            a.IsForm2Provided = (0, EntityUtil_1.toInt)(entity.IsForm2Provided);
            a.IsForm3Provided = (0, EntityUtil_1.toInt)(entity.IsForm3Provided);
            a.AreMinReqsMet = (0, EntityUtil_1.toInt)(entity.AreMinReqsMet);
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.FWpDoc = this.mergeArray(a.FWpDoc, b.FWpDoc, FWpDoc_1.FWpDoc);
            a.SelectedFWpDoc = a.SelectedFWpDoc && a.FWpDoc.find(x => x.Id == a.SelectedFWpDoc.Id) ? a.SelectedFWpDoc : null;
            a.FWpPr = this.mergeArray(a.FWpPr, b.FWpPr, FWpPr_1.FWpPr);
            a.SelectedFWpPr = a.SelectedFWpPr && a.FWpPr.find(x => x.Id == a.SelectedFWpPr.Id) ? a.SelectedFWpPr : null;
            a.FWpAsset = this.mergeArray(a.FWpAsset, b.FWpAsset, FWpAsset_1.FWpAsset);
            a.SelectedFWpAsset = a.SelectedFWpAsset && a.FWpAsset.find(x => x.Id == a.SelectedFWpAsset.Id) ? a.SelectedFWpAsset : null;
            a.FWpEoiInfo = this.mergeArray(a.FWpEoiInfo, b.FWpEoiInfo, FWpEoiInfo_1.FWpEoiInfo);
            a.SelectedFWpEoiInfo = a.SelectedFWpEoiInfo && a.FWpEoiInfo.find(x => x.Id == a.SelectedFWpEoiInfo.Id) ? a.SelectedFWpEoiInfo : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.Approval && this.Approval.evaluateStatus();
        }
        onReady() {
            this.Approval = new FWpApproval_1.FWpApproval(this);
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWorksProject.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "FacilityId", "FACILITY_ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
                this.validateReqString(validationState, "Lga", "LGA");
                this.validateReqString(validationState, "LgaCode", "Lga Code");
                this.validateReqNumber(validationState, "Status", "Status (Actual)");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqNumber(validationState, "IsForm2Provided", "Is Form2 Provided?");
                this.validateReqNumber(validationState, "IsForm3Provided", "Is Form3 Provided?");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FWpDoc) {
                for (let x of this.FWpDoc) {
                    x.walk(func, { leading });
                }
            }
            if (this.FWpPr) {
                for (let x of this.FWpPr) {
                    x.walk(func, { leading });
                }
            }
            if (this.FWpAsset) {
                for (let x of this.FWpAsset) {
                    x.walk(func, { leading });
                }
            }
            if (this.FWpEoiInfo) {
                for (let x of this.FWpEoiInfo) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                FacilityId: this.FacilityId,
                RefId: this.RefId,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                Desc_: this.Desc_,
                UserComment: this.UserComment,
                EoiApproxCost: this.EoiApproxCost,
                Quote: this.Quote,
                ApprovedAmt: this.ApprovedAmt,
                ClaimAmt: this.ClaimAmt,
                PaidAmt: this.PaidAmt,
                RecContractor: this.RecContractor,
                Status: this.Status,
                StatusReq: this.StatusReq,
                StatusPrev: this.StatusPrev,
                StatusDate: this.StatusDate,
                StatusUser: this.StatusUser,
                StatusComment: this.StatusComment,
                SystemState: this.SystemState,
                DateEoi: this.DateEoi,
                DatePa: this.DatePa,
                DateQuoted: this.DateQuoted,
                DateApproved: this.DateApproved,
                DateClaimed: this.DateClaimed,
                DatePaid: this.DatePaid,
                DateWithdrawn: this.DateWithdrawn,
                IsForm2Provided: this.IsForm2Provided,
                IsForm3Provided: this.IsForm3Provided,
                AreMinReqsMet: this.AreMinReqsMet,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                FWpDoc: this.FWpDoc.map(x => x.toJson()),
                FWpPr: this.FWpPr.map(x => x.toJson()),
                FWpAsset: this.FWpAsset.map(x => x.toJson()),
                FWpEoiInfo: this.FWpEoiInfo.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get StatusValue() {
            var _a;
            let k = this.StatusReq ? this.StatusReq : this.Status;
            let v = (_a = domain_1.FacilityWpStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.StatusReq ? `${v}*` : v;
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.FacilitySysStatusDomain.Archived || this.Status == domain_1.FacilityWpStatusDomain.Completed;
        }
        get IsActive() {
            return this.SystemState == domain_1.FacilitySysStatusDomain.Active;
        }
        static create(f) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Works Project");
                services_1.SrmsServiceManager.Instance.Facility.createFacilityWorks(f.toJson()).then(wp => {
                    let x = new FWorksProject(wp, f);
                    f.FWorksProject.push(x);
                    resolve(x);
                });
            });
        }
        lazyLoad() {
            return new Promise((resolve, reject) => {
                if (this.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.IsLoaded = true;
                }
                if (!this.IsLoaded) {
                    (0, EventManager_1.notify)("Loading Works Project");
                    services_1.SrmsServiceManager.Instance.Facility.readFacilityWorksProject(this.Id, true).then(wp => {
                        this.merge(wp);
                        this.IsLoaded = true;
                        resolve(this);
                    });
                }
                resolve(null);
            });
        }
        calculateFees() {
            this.EoiApproxCost = this.FWpEoiInfo.reduce((prev, cur) => prev + cur.CostEstimate, 0);
        }
    }
    exports.FWorksProject = FWorksProject;
    Object.defineProperty(FWorksProject, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWorksProject"
    });
    Object.defineProperty(FWorksProject, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project"
    });
    Object.defineProperty(FWorksProject, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "FacilityId", "RefId", "Lga", "LgaCode", "Desc_", "UserComment", "EoiApproxCost", "Quote", "ApprovedAmt", "ClaimAmt", "PaidAmt", "RecContractor", "Status", "StatusReq", "StatusPrev", "StatusDate", "StatusUser", "StatusComment", "SystemState", "DateEoi", "DatePa", "DateQuoted", "DateApproved", "DateClaimed", "DatePaid", "DateWithdrawn", "IsForm2Provided", "IsForm3Provided", "AreMinReqsMet", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate"]
    });
    Object.defineProperty(FWorksProject, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(FWorksProject, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 128
    });
    Object.defineProperty(FWorksProject, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(FWorksProject, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "Desc_Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWorksProject, "Desc_Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "UserCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FWorksProject, "UserCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "EoiApproxCostReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "QuoteReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "ApprovedAmtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "ClaimAmtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "PaidAmtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "RecContractorLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWorksProject, "RecContractorReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "StatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "StatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "StatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "StatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "StatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "StatusUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWorksProject, "StatusUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "StatusCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2046
    });
    Object.defineProperty(FWorksProject, "StatusCommentTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter any supporting information relevant to the approval decision"
    });
    Object.defineProperty(FWorksProject, "StatusCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "DateEoiReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DatePaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DateQuotedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DateApprovedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DateClaimedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DatePaidReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "DateWithdrawnReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "IsForm2ProvidedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "IsForm3ProvidedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "AreMinReqsMetReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWorksProject, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWorksProject, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWorksProject, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWorksProject, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Desc_", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Desc_Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "UserComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "UserCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "EoiApproxCost", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "EoiApproxCostError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Quote", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "QuoteError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "ApprovedAmt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "ApprovedAmtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "ClaimAmt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "ClaimAmtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "PaidAmt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "PaidAmtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "RecContractor", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "RecContractorError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "StatusCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateEoi", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateEoiError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DatePa", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DatePaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateQuoted", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateQuotedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateApproved", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateApprovedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateClaimed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateClaimedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DatePaid", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DatePaidError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateWithdrawn", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "DateWithdrawnError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "IsForm2Provided", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "IsForm2ProvidedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "IsForm3Provided", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "IsForm3ProvidedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AreMinReqsMet", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AreMinReqsMetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SelectedFWpDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpPr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SelectedFWpPr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpPrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SelectedFWpAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpEoiInfo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "SelectedFWpEoiInfo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "FWpEoiInfoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Facility", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWorksProject.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWorksProject.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWorksProject.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "Approval", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "NewDocType", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWorksProject.prototype, "StatusValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWorksProject.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWorksProject.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWorksProject.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWorksProject.prototype, "IsLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWorksProject.prototype, "calculateFees", null);
});
